module.exports = __webpack_public_path__ + "static/media/MANGUERA.9c02e0bf.jpg";